module.exports = __webpack_public_path__ + "img/Background.adb251f2.png";